import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { PermissionService } from 'app/core/permissions/permission.service';

/**
 * Admin Guard
 * 
 * Restricts route access to Admin users only.
 * Redirects unauthorized users to the dashboard.
 * 
 * Usage in routes:
 * ```typescript
 * {
 *   path: 'users',
 *   canActivate: [AdminGuard],
 *   component: UsersComponent
 * }
 * ```
 */
export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const permissionService: PermissionService = inject(PermissionService);

    if (permissionService.isAdmin()) {
        return true;
    }

    console.warn('[AdminGuard] Access denied - Admin role required', {
        currentRole: permissionService.getCurrentUserRole(),
        route: state.url
    });

    router.navigate(['/home']);
    return false;
};
